import establishEvents from './establish'
import mediaEvents from './media'
import complexEvents from './complex'
import miscEvents from './misc'

export const callEvents = {
  ...establishEvents,
  ...mediaEvents,
  ...complexEvents,
  ...miscEvents
}

export default callEvents
